
import { ToList } from "../../model/LoginUserInfo/ToList";
import { CcList } from "../../model/LoginUserInfo/CcList";
import { InqTemplateShareToGrp } from "../../model/user-profile/inqTemplateShareToGrp";
import { ShareToGrpList } from "../../model/LoginUserInfo/ShareToGrpList";

export class InquiryTemplate {
    name?: string;
    value?: string;
    templateName: string;
    templateContent: string;
    templateSubject: string;
    toList?: ToList[];
    ccList?: CcList[];
    shareToGrpList?: ShareToGrpList[];
    inqTemplateShareToGrp?: InqTemplateShareToGrp[];
    delTempGrpList?: string[];
    inqTemplateTo?: ToList[];
    inqTemplateCc?: CcList[];
    active?: boolean;
    modified?: number;
    modifiedBy?: string;
    mergeRecipients?: boolean;
}